<template>
    <div>
        <button-tooltip icon :tooltip="$t('common.filter')" @click="showFilter">
            <v-icon size="20" :color="hasFilter ? 'accent' : 'txtSecondary'">
                {{ hasFilter ? 'mdi-filter' : 'mdi-filter-outline' }}
            </v-icon>
        </button-tooltip>

        <filter-coach-dialog ref="filter"/>
    </div>
</template>

<script>

import FilterCoachDialog from '@/components/student/FilterCoachDialog'
import ButtonTooltip from '@/components/common/ButtonTooltip'

import { mapState } from 'vuex'

const DEFAULT_FILTER = '(accountType:coach AND readyToTrain=1) '

export default {
    components: {
        FilterCoachDialog,
        ButtonTooltip,
    },
    computed: {
        ...mapState(['filterCoach']),
        hasFilter(vm = this) {
            return vm.filterCoach !== DEFAULT_FILTER
        },
    },
    methods: {
        showFilter() {
            const vm = this
            vm.$refs.filter.show()
        }
    },
}
</script>
